// lib/downloadPdf.ts

export type Booking = {
  id: string;
  branch: string;
  category: string;
  datetime: string;
  cnr: string;
  status: "completed" | "expired" | "upcoming";
  raw?: any;
};

export function downloadPdf(bk: Booking) {
  if (typeof window === 'undefined') {
    console.error('downloadPdf can only be called in the browser')
    return
  }

  const qrUrl = `https://api.qrserver.com/v1/create-qr-code/?size=240x240&data=${encodeURIComponent(
    bk.cnr ?? bk.id
  )}`;

  const userName =
    bk.raw?.user?.name ??
    bk.raw?.createdBy?.name ??
    bk.raw?.created_by?.name ??
    bk.raw?.userName ??
    "—";

  const html = `
    <html>
      <head>
        <title>Ticket - ${bk.cnr}</title>
        <style>
          body{font-family: Inter, Arial, sans-serif;padding:24px;color:#222}
          .card{max-width:520px;margin:0 auto;border-radius:12px;padding:20px;border:1px solid #eee}
          .brand{display:flex;gap:8px;align-items:center;justify-content:center;margin-bottom:12px}
          .label{font-weight:600;color:#6b7280;margin-bottom:6px}
          .value{font-weight:700;margin-bottom:12px}
          .qr{display:flex;justify-content:center;margin:18px 0}
          .footer{font-size:13px;color:#6b7280;text-align:center}
        </style>
      </head>
      <body>
        <div class="card">
          <div class="brand">
            <div style="color:#ff2b7a;font-weight:800">CHECHE</div>
            <div style="color:#2b2d42;font-weight:700">Qetero</div>
          </div>

          <div>
            <div class="label">User:</div>
            <div class="value">${userName}</div>

            <div class="label">Branch:</div>
            <div class="value">${bk.branch}</div>

            <div class="label">Service:</div>
            <div class="value">${bk.category}</div>

            <div class="label">Time:</div>
            <div class="value">${bk.datetime}</div>
          </div>

          <div class="qr">
            <img src="${qrUrl}" alt="qr" />
          </div>

          <div class="footer">
            Use the QR code to manage your Qetero and to get your booking detail.
          </div>
        </div>
        <script>setTimeout(()=>{ window.print(); }, 300);</script>
      </body>
    </html>
  `;

  const w = window.open("", "_blank", "width=700,height=900");
  if (w) {
    w.document.open();
    w.document.write(html);
    w.document.close();
  } else {
    alert("Please allow popups to download the ticket.");
  }
}
